import { getCommonWidget } from '../../dashWidgetHelper'
import { commonWidgets, NETPAY_COLORS_NPS, NETPAY_SCALE_3_COLORS } from '../commonWidgetsNetpay'
import { List } from 'immutable';

const MAP_LABELS_MOTIVO_CALIFICACION_PROMOTORES: { [key: number]: string } = {
    1: "Solicitud de rollos",
    2: "Depósito de mis ventas",
    3: "Funcionalidades con la terminal",
    4: "Buena aceptación de tarjetas",
    5: "Reportería",
    6: "Calidad en el servicio call center",
    7: "Calidad en servicio socio comercial",
    8: "Procesamiento de ventas",
    9: "Beneficios NetPay",
    10: "Otro"
};

const MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES: { [key: string]: { [key: number]: string } } = {
    SOLICITUD_ROLLOS: {
        1: "Tiempo de entrega adecuado",
        2: "Cantidad de rollos adecuada",
    },
    DEPOSITO_VENTAS: {
        3: "Puntualidad en el depósito de mis ventas",
        4: "Claridad en los depósitos de mis ventas",
    },
    FUNCIONALIDADES_TERMINAL: {
        5: "Me permite hacer cobros con tarjetas internacionales",
        6: "Facilidad para agregar propina",
        7: "Facilidad para hacer cortes",
    },
    BUENA_ACEPTACION_TARJETAS: {},
    REPORTERIA: {
        8: "Velocidad de descarga",
        9: "Relevancia de la información",
    },
    CALIDAD_SERVICIO_CALL_CENTER: {
        10: "Amabilidad y empatía",
        11: "Atención rápida",
    },
    CALIDAD_SERVICIO_SOCIO_COMERCIAL: {
        12: "Seguimiento puntual",
        13: "Comunicación",
    },
    PROCESAMIENTO_VENTAS: {
        14: "Rapidez para procesar las ventas",
        15: "Claridad en la información al realizar una venta",
    },
    BENEFICIOS_NETPAY: {
        16: "Acceso al portal Manager para visualizar reportería",
        17: "Integraciones personalizadas para mi negocio",
        18: "Funcionalidad general de los productos",
        19: "Confianza en el servicio y productos",
        20: "Cercanía para atender mis necesidades",
    },
    OTRO: {},
};

const MAP_LABELS_MOTIVO_CALIFICACION_DETRACTORES: { [key: number]: string } = {
    1: "Calidad en servicio con CC",
    2: "Temas con la terminal",
    3: "Depósito de mis ventas",
    4: "Comisión",
    5: "Reportería",
    6: "Solicitud de rollos",
    7: "Calidad en servicio con Socio / Asesor Comercial",
    8: "Calidad de los materiales de la terminal",
    9: "Procesamiento de venta",
    10: "Modificación de datos",
    11: "Fallas en el portal Manager",
};

const MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES: { [key: string]: { [key: number]: string } } = {
    CALIDAD_SERVICIO_CALL_CENTER: {
        1: "No estoy satisfecho por el servicio recibido por el agente",
        2: "Proporcionó información incorrecta",
        3: "No se resolvió mi solicitud",
    },
    TEMAS_CON_LA_TERMINAL: {
        4: "Pantalla congelada",
        5: "Calidad del equipo (resistencia)",
        6: "Error de lectura",
        7: "Tarjeta rechazada",
        8: "Batería no dura",
        9: "Chip no detectado",
        10: "Falla por conexión WiFi",
        11: "Falla por conexión por datos móviles",
        12: "Lentitud al procesar transacciones",
        13: "No imprime tickets",
    },
    DEPOSITO_DE_MIS_VENTAS: {
        14: "No veo el depósito reflejado en Manager",
        15: "No me han depositado",
        16: "Mi depósito se abonó tarde",
        17: "No concilia mi depósito",
    },
    COMISION: {
        18: "La tasa no es competitiva",
        19: "La tasa no es la pactada",
    },
    REPORTERIA: {
        20: "Velocidad de descarga",
        21: "Relevancia de la información",
        22: "Históricos de información",
        23: "Capacidad de integración",
        24: "Reportes a la medida",
    },
    SOLICITUD_ROLLOS: {
        25: "Se demoró la entrega de mis rollos",
        26: "No recibí mis rollos",
        27: "La cantidad de rollos no es adecuada",
    },
    CALIDAD_SERVICIO_SOCIO_COMERCIAL: {
        28: "Falta de comunicación",
        29: "Falta de seguimiento",
        30: "El servicio brindado no fue el adecuado",
    },
    MATERIALES_TERMINAL: {
        31: "Botones con mala calidad",
        32: "Pantalla frágil",
        33: "Plástico con mala calidad",
    },
    PROCESAMIENTO_DE_VENTA: {
        34: "Venta reversada",
        35: "Venta rechazada",
        36: "Cancelación de venta",
        37: "Devolución",
    },
    MODIFICACION_DE_DATOS: {
        38: "El proceso fue complicado",
        39: "El proceso demoró mucho",
        40: "Me rechazaron mi documentación",
    },
    FALLAS_EN_PORTAL_MANAGER: {
        41: "No puedo ingresar (usuario / contraseña)",
        42: "Presenta errores",
        43: "Tarda mucho en responder",
    },
};

const getPieSubmotivo = (indicator: string, title: string, mapLabels: { [key: number]: string }) => {
    return getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'pieGenericMedium',
        title,
        size: [2, 2],
        indicator,
        mapper: (data: any) => {
            const filteredData = [...data].filter((a: any) => a.groupId in mapLabels);
            const total = filteredData.reduce((sum, item) => sum + item.count, 0);
            return filteredData.map((item: any) => ({
                ...item,
                value: total > 0 ? (item.count / total) * 100 : 0,
                label: `${mapLabels[item.groupId]} (${item.count})`,
            }));
        },
        extraConfigs: {
            colors: NETPAY_COLORS_NPS,
            crossFilter: true,
            enableCrossFilter: true,
        }
    });
};

export default {
    title: 'Experiencia Honda Dashboard',
    description: 'Dashboard de perfil Honda',
    backgroundClassName: (filters) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {
        return [

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'multipleTrendByMonth',
                title: 'NPS',
                size: [2, 2],
                key: 'nps-multiple-trend-by-month',
                indicator: 'np_nps_recomiendacion_netpay',
                mapper: (data, extra) => {
                    return data.map((item: any, idx: any) => ({
                        ...item,
                        groupName: item.groupName + ' (' + item.value + ')',
                    }))
                },
                extraConfigs: {
                    colors: NETPAY_COLORS_NPS,
                    useCurrent: 0,
                    categories: ['promoters', 'passives', 'detractors'],
                    categoriesLabel: ['Promotores', 'Neutros', 'Detractores'],
                    crossFilter: true,
                    enableCrossFilter: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'semicircleGeneric',
                title: 'Composición NPS',
                key: 'nps-por-mes',
                size: [2, 2],
                indicator: 'np_nps_recomiendacion_netpay',
                extraConfigs: {
                    colors: NETPAY_SCALE_3_COLORS,
                    categories: ['promoters', 'passives', 'detractors'],
                    useEmojis: false,
                    crossFilter: true,
                    enableCrossFilter: true,
                },
            }),

            { title: 'MOTIVOS DE CALIFICACIÓN', type: 'label', size: [4, 1], config: { color: '#B7AADC' } },

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'Promotores (9-10)',
                size: [2, 3],
                indicator: 'np_nps_motivo_calificacion',
                mapper: (data: any) => {
                    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                        ...item,
                        label: `${MAP_LABELS_MOTIVO_CALIFICACION_PROMOTORES[item.groupId]} (${item.count})`,
                        //groupName: item.groupId,//DEFAULT_GROUP_LABELS[item.groupId] || item.groupName
                    }))
                },
                extraConfigs: {
                    colors: NETPAY_COLORS_NPS,
                    crossFilter: true,
                    enableCrossFilter: true,
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'pieGenericMedium',
                title: 'Detractores y Neutros (0-8)',
                size: [2, 3],
                indicator: 'np_nps_motivo_calificacion_detractor',
                mapper: (data: any) => {
                    //console.log('Mapper misión principal de la visita')
                    //console.log(data)
                    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                        ...item,
                        label: `${MAP_LABELS_MOTIVO_CALIFICACION_DETRACTORES[item.groupId]} (${item.count})`,
                        //groupName: item.groupId,//DEFAULT_GROUP_LABELS[item.groupId] || item.groupName
                    }))
                },
                extraConfigs: {
                    colors: NETPAY_COLORS_NPS,
                    crossFilter: true,
                    enableCrossFilter: true,
                }
            }),

            { title: 'SUBMOTIVOS DE PROMOTORES', type: 'label', size: [4, 1] },

            getPieSubmotivo('np_nps_submotivo', 'Solicitud de rollos', MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES.SOLICITUD_ROLLOS),
            getPieSubmotivo('np_nps_submotivo', 'Depósito de mis ventas', MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES.DEPOSITO_VENTAS),
            getPieSubmotivo('np_nps_submotivo', 'Funcionalidades con la terminal', MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES.FUNCIONALIDADES_TERMINAL),
            //getPieSubmotivo('np_nps_submotivo','Buena aceptación de tarjetas', MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES.BUENA_ACEPTACION_TARJETAS),
            getPieSubmotivo('np_nps_submotivo', 'Reportería', MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES.REPORTERIA),
            getPieSubmotivo('np_nps_submotivo', 'Calidad en el servicio call center', MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES.CALIDAD_SERVICIO_CALL_CENTER),
            getPieSubmotivo('np_nps_submotivo', 'Calidad en servicio socio comercial', MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES.CALIDAD_SERVICIO_SOCIO_COMERCIAL),
            getPieSubmotivo('np_nps_submotivo', 'Procesamiento de ventas', MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES.PROCESAMIENTO_VENTAS),
            getPieSubmotivo('np_nps_submotivo', 'Beneficios NetPay', MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES.BENEFICIOS_NETPAY),
            //getPieSubmotivo('np_nps_submotivo','Otro', MAP_LABELS_SUBMOTIVO_CALIFICACION_PROMOTORES.OTRO),

            { title: 'SUBMOTIVOS DE DECTRATORES Y NEUTORS', type: 'label', size: [4, 1] },

            getPieSubmotivo('np_nps_submotivo_detractor', 'Calidad en Servicio Call Center', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.CALIDAD_SERVICIO_CALL_CENTER),
            getPieSubmotivo('np_nps_submotivo_detractor', 'Temas con la terminal', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.TEMAS_CON_LA_TERMINAL),
            getPieSubmotivo('np_nps_submotivo_detractor', 'Depósito de mis ventas', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.DEPOSITO_DE_MIS_VENTAS),
            getPieSubmotivo('np_nps_submotivo_detractor', 'Comisión', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.COMISION),
            getPieSubmotivo('np_nps_submotivo_detractor', 'Reportería', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.REPORTERIA),
            getPieSubmotivo('np_nps_submotivo_detractor', 'Solicitud de rollos', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.SOLICITUD_ROLLOS),
            getPieSubmotivo('np_nps_submotivo_detractor', 'Calidad en servicio socio comercial', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.CALIDAD_SERVICIO_SOCIO_COMERCIAL),
            getPieSubmotivo('np_nps_submotivo_detractor', 'Calidad de los materiales de la terminal', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.MATERIALES_TERMINAL),
            getPieSubmotivo('np_nps_submotivo_detractor', 'Procesamiento de venta', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.PROCESAMIENTO_DE_VENTA),
            getPieSubmotivo('np_nps_submotivo_detractor', 'Modificación de datos', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.MODIFICACION_DE_DATOS),

            getPieSubmotivo('np_nps_submotivo_detractor', 'Fallas en el portal Manager', MAP_LABELS_SUBMOTIVO_CALIFICACION_DETRACTORES.FALLAS_EN_PORTAL_MANAGER),

            { title: '', size: [2, 2], type: 'empty-space', },

            // -----------------------------------------------------------
            // ETIQUETAS DE SENTIMIENTO
            // -----------------------------------------------------------
            { title: 'ANÁLISIS DE SENTIMIENTOS', type: 'label', size: [4, 1], config: { color: '#B7AADC' } },

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'textAnalysis',
                size: [4, 4], // 
                key: 'analisis-sentimientos-nlp',
                indicator: 'sentiment',
                extraConfigs: {
                    colors: NETPAY_SCALE_3_COLORS,
                    typeColumn: 'percent',
                    widgetTitle: 'Etiquetas de Sentimientos',
                    groupKeys: ['positive', 'neutral', 'negative'],
                    groupLabels: { 'positive': 'Promotores', 'neutral': 'Neutros', 'negative': 'Detractores' },
                    defaultHeight: 600,
                },
                mapper: (data: any, extra?: any) => {
                    const actualData = Array.isArray(data) ? data[0] : data;

                    if (!actualData || !actualData.categories) {
                        return { ...actualData, categories: List([]) };
                    }

                    let categories = actualData.categories || [];
                    let sortedCategories = [...categories].sort((a: any, b: any) => b.count - a.count);

                    const splitTags = (item: any[]): any[] => {
                        const tags = [...(item || [])].sort((a: any, b: any) => b.count - a.count);
                        return tags.map((tag: any) => ({
                            ...tag,
                            tags: splitTags(tag.tags),
                        }));
                    };

                    sortedCategories = sortedCategories.map((item: any) => ({
                        ...item,
                        tags: splitTags(item.tags),
                    }));

                    return {
                        ...actualData,
                        categories: List(sortedCategories),
                    }
                },
            }),

            // --- Nube de Palabras ---
            { title: 'Nube de Palabras', type: 'label', size: [4, 1], config: { color: '#B7AADC' } },

            {
                title: 'Frecuencia de Palabras',
                size: [4, 2],
                config: {
                    id: 'word-count-nps',
                    type: 'wordCloud',
                    mapper: (data: any, extra: any) => {
                        return data !== undefined && data.map !== undefined
                            ? data.map((item: any) => ({
                                ...item,
                                group: item.group ?? item.category
                            }))
                            : []
                    },
                    indicators: [
                        {
                            indicator: 'WORD_COUNT',
                            keyExtract: ['count', 'value', 'group', 'category'],
                            singleton: true,
                        },
                    ],
                },
            },

            // -----------------------------------------------------------
            // NPS POR SEGMENTO Y GIRO
            // -----------------------------------------------------------
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'barByQuestionNps',
                key: 'Nps-por-segmento',
                title: 'Nps por segmento',
                size: [4, 3],
                indicator: 'np_nps_recomiendacion_netpay',
                extras: {
                    formula: 'nps-10',
                    groupByResponseValueId: 29804,
                    groupBy: "responseValue",
                },
                mapper: (data: any) => {
                    return data.map((item: any) => ({
                        ...item,
                        groupName: item.groupName ? item.groupName.trim() : 'No Definido'
                    }));
                },
                extraConfigs: {
                    colors: NETPAY_SCALE_3_COLORS,
                    groupKeys: ['promoters', 'passives', 'detractors'],
                    groupLabels: { 'promoters': 'Promotores', 'passives': 'Neutros', 'detractors': 'Detractores' },
                    decimals: 0,
                    crossFilter: true,
                    enableCrossFilter: true,
                    showCountInLabel: true,
                    showNpsLine: true
                }
            }),

            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'verticalStackedBar',
                key: 'Nps-por-giro',
                title: 'Nps por giro',
                size: [4, 3],
                indicator: 'np_nps_recomiendacion_netpay',
                extras: {
                    formula: 'nps-10',
                    groupByResponseValueId: 29803,
                    groupBy: "responseValue",
                },

                mapper: (data: any) => {
                    return data.map((item: any) => ({
                        ...item,
                        groupName: item.groupName ? item.groupName.trim() : 'Otro'
                    }));
                },
                extraConfigs: {
                    isHybridNps: true,
                    colors: { 'volumeHigh': '#00b050', 'volumeMid': '#FFD01B', 'volumeLow': '#ff0000', 'nps': '#0C84AD' },
                    groupLabels: { 'volume': 'Encuestas', 'nps': 'NPS' },
                    decimals: 0,
                    crossFilter: true,
                    enableCrossFilter: true,
                }
            })

        ]
    },
} as DasboardConfig;